import { colors, ColorVariant, Stack, Typography } from '@ui-components/neo.tax';

import { StyledSwitch } from './rd-project-eligibility.styled';

export const SectionElectionToggle = ({
  checked,
  id,
  onChange,
  subtitle,
  title,
  variant,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  variant: ColorVariant;
  subtitle: string;
  title: string;
  id: string;
}): React.ReactElement => (
  <Stack gap={3} paddingY={1}>
    <StyledSwitch id={id} withIcon checked={checked} onChange={onChange} variant={variant} />
    <Stack direction="column">
      <Typography as="label" fontSize="sm" fontWeight="medium" color={colors.gray[700]}>
        {title}
      </Typography>
      <Typography fontSize="xs" fontWeight="medium" color={colors.gray[500]}>
        {subtitle}
      </Typography>
    </Stack>
  </Stack>
);
